import styles from './Card.module.css'

export default function Card({item}) {
  return (
    <div className={styles.card}>
        <img className={styles.icone} src={item.icone} alt={"ícone da formação: "+item.nome} />
        <h4 className={styles.nome}>{item.nome}</h4>
        <p className={styles.texto}>{item.texto}</p>
        <a className={styles.botao} href={item.link}>Visitar</a>
    </div>
  )
}
